import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * Federated ingredient catalog — fetches the full upstream list from
 * api-food-preferences-v2-service (which caches it 30 min from
 * api-recipes-service `/v1/ingredients/all`). Frontend filters locally on
 * every keystroke — no per-keystroke round-trip. Envelope: `{data: [{id,
 * name, category}]}`.
 */
class IngredientsCatalogService {
  constructor() {
    this.apiService = new APIService();
  }

  list(onResponse, onError) {
    const url = APIConfig.foodPreferencesV2.ingredients;
    return this.apiService.get(
      url,
      (res) => onResponse((res && res.data) || []),
      onError
    );
  }
}

export default IngredientsCatalogService;
